module.exports = __webpack_public_path__ + "img/7-compressor.71e1e19d.png";